import {useEffect} from 'react'
import {useLocation} from 'react-router-dom'
import {reInitMenu} from '../helpers'

// The only part of the layout shell that watches the router: the Metronic
// menus are re-initialised when the *pathname* changes, from this
// null-rendering child, so a query-string rewrite (a list's search box,
// ADR-0018) re-renders neither the header, the sidebar, the toolbar nor the
// footer (ADR-0022).
const LocationMenuReinit = () => {
  const {pathname} = useLocation()
  useEffect(() => {
    reInitMenu()
  }, [pathname])
  return null
}

export {LocationMenuReinit}
